import { useSelector } from 'react-redux';

import { formatNumberAndCents } from '@makemydeal/dr-common-utils';
import { DUE_AT_SIGNING, SummaryDueAtSigningSlideOut, useSummaryDueAtSigning } from '@makemydeal/dr-dash-components';
import * as compositeSelectors from '@makemydeal/dr-dash-store/selectors/compositeSelectors';

import { OutOfFlowHost, ReadOnlyValue } from '../../../ScenarioGrid.style';
import { RowLabelAction } from '../../RowLabelAction';
import { ScenarioRow } from '../../ScenarioRow';

export const DueAtSigningRow = () => {
    const dueAtSigning = useSelector(compositeSelectors.getTotalAmountDue);
    const { showSlideOut, toggleSlideOut, overrides } = useSummaryDueAtSigning();

    return (
        <ScenarioRow
            rowKey="dueAtSigning"
            label={
                <RowLabelAction onActivate={toggleSlideOut} testId="due-at-signing-summary-label">
                    {DUE_AT_SIGNING}
                </RowLabelAction>
            }
        >
            <ReadOnlyValue data-testid="due-at-signing-summary-numeric-value">${formatNumberAndCents(dueAtSigning)}</ReadOnlyValue>
            {showSlideOut && (
                <OutOfFlowHost>
                    <SummaryDueAtSigningSlideOut show={showSlideOut} onHide={toggleSlideOut} overrides={overrides} />
                </OutOfFlowHost>
            )}
        </ScenarioRow>
    );
};
